
import {
  defineComponent, onBeforeMount, reactive, ref, computed,
  watch,
} from 'vue';
import {
  Card,
} from 'ant-design-vue'; // Importar Table e Tabs
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import Icone from '@/core/components/Icone.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import ServicoRelatoriosVendas from '@/servicos/Relatorios/ServicoRelatoriosVendas';
import { IFiltrosRelatorioCurvaABC } from '@/models/Relatorios/Venda/IFiltrosRelatorioCurvaABC';
import { useTelaBase } from '@/core/composables/TelaBase';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import SelecionarAnaliseCurvaAbc from '@/components/Relatorios/Vendas/CurvaAbc/SelecionarAnaliseCurvaAbc.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { IDadosRelatorioCurvaABC } from '@/models/Relatorios/Venda/IDadosRelatorioCurvaAbc';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { useGradeBase } from '@/core/composables/GradeBase';

export default defineComponent({
  name: 'RelatorioCurvaABCIndex',
  components: {
    TituloPadrao,
    Card,
    Icone,
    PreviewPdf,
    SelecionarDataInicialFinal,
    SelecionarProduto,
    SelecionarAnaliseCurvaAbc,
    CampoNumerico,
  },
  setup(props) {
    const dadosEmpresa = ref<IDTODadosEmpresa>({} as IDTODadosEmpresa);
    const servicoRelatorioVenda = new ServicoRelatoriosVendas();

    const {
      telaBase,
      apresentarMensagemAlerta,
      apresentarMensagemErro,
      preencherEmpresasDisponiveis,
    } = useTelaBase();

    const { gradeBase } = useGradeBase();

    const state = reactive({
      identificadorRecurso: 'RELATORIO_CURVA_ABC',
      tituloRecurso: 'Relatorio Curva ABC',
      dataInicial: '',
      dataFinal: '',
      empresaSelecionada: 0,
      arquivoPdf: [] as IArquivoPdf[],
      tipoAnalise: 0,
      produtos: [] as number[],
      mostraFiltros: ['1'],
      classeA: 0,
      classeB: 0,
      classeC: 0,
      dadosRelatorio: {} as IDadosRelatorioCurvaABC,
      filtros: {} as IFiltrosRelatorioCurvaABC,
    });

    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Item', position: 1, visible: false,
          },
          {
            title: 'Produto', dataIndex: 'descricao', key: 'descricao', position: 2, visible: true,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Cód.',
            dataIndex: 'codigo',
            key: 'codigo',
            width: 80,
            position: 0,
            visible: true,
          },
          {
            title: 'Descrição',
            dataIndex: 'descricao',
            key: 'descricao',
            position: 1,
            visible: true,
          },
          {
            title: 'Qtd.',
            dataIndex: 'quantidade',
            key: 'quantidade',
            width: 150,
            align: 'right',
            position: 2,
            visible: true,
          },
          {
            title: 'Faturamento',
            dataIndex: 'faturamento',
            key: 'faturamento',
            width: 150,
            align: 'right',
            position: 3,
            visible: true,
          },
          {
            title: 'Lucratividade',
            dataIndex: 'lucratividade',
            key: 'lucratividade',
            width: 150,
            align: 'right',
            position: 4,
            visible: true,
          },
        ];
      }
    }

    const temDados = computed(() => (state.dadosRelatorio.itensClasseA && state.dadosRelatorio.itensClasseA.length > 0)
               || (state.dadosRelatorio.itensClasseB && state.dadosRelatorio.itensClasseB.length > 0)
               || (state.dadosRelatorio.itensClasseC && state.dadosRelatorio.itensClasseC.length > 0));

    function limparFiltros() {
      state.filtros = {} as IFiltrosRelatorioCurvaABC;
      state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
      state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
      state.tipoAnalise = 1;
      state.classeA = 40;
      state.classeB = 30;
      state.classeC = 30;
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      state.dadosRelatorio = {} as IDadosRelatorioCurvaABC;
    }

    async function buscarRelatorio() {
      telaBase.carregando = true; // Importante ativar o loading
      try {
        const filtros = {} as IFiltrosRelatorioCurvaABC;

        filtros.empresa = state.empresaSelecionada;
        filtros.dataInicial = state.dataInicial;
        filtros.dataFinal = state.dataFinal;
        filtros.produtos = state.produtos;
        filtros.tipoAnalise = state.tipoAnalise;
        filtros.percClasseA = state.classeA;
        filtros.percClasseB = state.classeB;
        filtros.percClasseC = state.classeC;
        state.filtros = filtros;
        preencherColunas();

        const resultado = await servicoRelatorioVenda.obterRelatorioCurvaABC(filtros);

        state.dadosRelatorio = resultado;

        if (temDados.value) state.mostraFiltros = [];
      } finally {
        telaBase.carregando = false;
      }
    }

    async function imprimir(tipoArquivoRelatorio: ETipoArquivo) {
      telaBase.carregando = true;

      if (!temDados.value) {
        await buscarRelatorio();
      }

      if (!temDados.value) {
        telaBase.carregando = false;
        apresentarMensagemAlerta('Nenhum dado encontrado para gerar o arquivo.');
        return;
      }

      const retornoRelatorio = await servicoRelatorioVenda.obterArquivRelatorioCurvaABC(
        tipoArquivoRelatorio,
        state.filtros,
      );

      telaBase.carregando = false;

      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{
            nome: 'RelatorioCurvaABC',
            link: retornoRelatorio.link,
          }];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      telaBase.identificadorRecurso = state.identificadorRecurso;

      await preencherEmpresasDisponiveis();
      preencherColunas();
      limparFiltros();
    });

    return {
      props,
      state,
      dadosEmpresa,
      buscarRelatorio,
      imprimir,
      ETipoArquivo,
      temDados,
      UtilitarioMascara,
      gradeBase,
    };
  },
});
